import * as d3 from 'd3';

let vaporCells = Array.from(Array(100).keys())
vaporCells = vaporCells.map(v => { return {'id': v}});

export default function () {
    const el = document.getElementById('vapor-graphic');

    const buttons = el.parentElement.getElementsByClassName('button');

    function update(cellCount) {
      let newCells = Array.from(Array(cellCount).keys())
      newCells = newCells.map(v => { return {'id': v }});
      
      const old = new Map(vaporCell.data().map(d => [d.id, d]));
      vaporCells = newCells.map(d => Object.assign(old.get(d.id) || {}, d));

      vaporCell = vaporCell
        .data(vaporCells, d => d.id)
        .join(enter => enter.append("circle")
          .attr('fill', d => {
            if (d.id > 99) { return '#FF7C05'}
            return '#3061f2'
          })
          .attr('stroke-width', 0)
          .attr('r', 8)
          .attr('cx', w/2)
          .attr('cy', h/2)
          );
        
      simulation.nodes(vaporCells);
      simulation.alpha(.8);
      simulation.restart();


    }

    function selectButton(evt) {
      for (let b of buttons) {
        b.classList.remove('selected');
      }
      evt.target.classList.add('selected');
      let temp = parseInt(evt.target.dataset.temp);
      if (temp == 1) {
        update(107);
      } else if (temp == 2) {
        update(114);
      } else {
        update(100);
      }

      
    }

    for (let b of buttons) {
      b.addEventListener('click', selectButton);
    }

    let w = el.clientWidth;
    let h = 300;
    let margin = 20;

    function ticked() {
      //vaporCell.attr('transform', d => `translate(${d.x}, ${d.y})`);
      vaporCell.attr("cx", d => d.x)
          .attr("cy", d => d.y)



    }

    const simulation = d3.forceSimulation()
      // .force('charge', d3.forceManyBody().strength(.5))
      .force('collision', d3.forceCollide(10))
      .force('x', d3.forceX(w/2 + margin))
      .force('y', d3.forceY(h/2 + margin))
      .on('tick', ticked);

    let vaporGraphic = d3.select('#vapor-graphic')
      .append('svg')
        .attr('width', w)
        .attr('height', h+margin+margin);



    let legend = vaporGraphic.append('g')
      .attr('class', 'legend')
      .attr('transform', `translate(${margin}, ${h})`);
    
    legend.append('circle')
      .attr('fill', '#808080')
      .attr('r', 8);
    
    legend.append('text')
      .text('1 water vapor unit')
      .attr('dx', margin/2+2)
      .attr('dy', '.3em');

    let vaporCell = vaporGraphic.append('g')
      .attr('class', 'cells')
      .selectAll('g')
      .data(vaporCells)
      .enter()
        .append('g')
          .attr('class', 'cell')
        .append('circle')
          .attr('fill', d => {
            if (d.id > 99) { return '#FF7C05'}
            return '#3061f2'
          })
          .attr('stroke-width', 0)
          .attr('r', 8);
          
    simulation.nodes(vaporCells);

    
/*
    let vaporCircle = vaporGraphic.append('g')
      .append('circle')
        .attr('r', h/2)
        .attr('cx', w/2 + margin)
        .attr('cy', h/2 + margin)
        .attr('stroke', '#000')
        .attr('stroke-width', '2')
        .attr('fill', 'none');

    console.log(vaporCircle);
*/


}




// WEBPACK FOOTER //
// ./src/js/proj/vapor.js